import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import moment from "moment-timezone";
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from 'slices/userSlice';

import LogsTable from './LogsTable';
import FullPageLoader from 'components/common/FullPageLoader';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { CheckinCheckoutAdjustmentModal } from 'components/appointment/checkinCheckoutAdjustment';
import CouldNotCover from 'components/appointment/CouldNotCover';
import DonotCover from 'components/appointment/DonotCover';
import CancelModal from 'components/vendorAccess/CancelModal';
import { setActionAssign, acceptVendorAppointment, setVendorActionAssign, updateVendorImsId } from 'slices/actionButtonSlice';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useForm, Controller } from 'react-hook-form';


import { fetchVendorAppointmentLogs, fetchVendorAppointmentNotificationLogs } from 'slices/vendor/appointmentSlice';
import { fetchVendorAppointmentView } from 'slices/vendor/appointmentSlice';
import SelectInterpreterModal from 'components/vendorAccess/SelectInterpreterModal';
import ExtraMileage from 'components/appointment/ExtraMileage';
import ViewTable from 'views/appointment/view/ViewTable';
import NotificationLogsTable from 'views/appointment/view/NotificationLogsTable';

const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const { user } = useSelector(userSelector);

    const [item, setItem] = React.useState({});

    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [notificationLogs, setNotificationLogs] = React.useState([]);
    const [selectedNotification, setSelectedNotification] = React.useState(null);
    const [notificationModal, setNotificationModal] = React.useState(false);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [extraMileage, setExtraMileage] = React.useState(false);
    const [modalType, setModalType] = React.useState('assign');
    const [imsModal, setImsModal] = React.useState(false);
    const { control: imsControl, handleSubmit: imsHandleSubmit, reset: imsReset } = useForm({
        defaultValues: { ims_id: '' }
    });


    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
            }
            else {
                if (message === "You are not authorized to view this appointment") {
                    toast.error(message, { className: "errorToast" });
                    navigate('/vendor/dashboard');
                }
            }
        }


        dispatch(fetchVendorAppointmentView(id, callBack))
    };


    const fetchNotificationLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setNotificationLogs(data);
            }
        };
        dispatch(fetchVendorAppointmentNotificationLogs(id, callBack));
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data);
            } else {
                console.log(message);
            }
        };
        dispatch(fetchVendorAppointmentLogs(id, callBack));
        fetchNotificationLogs();
    };

    React.useEffect(() => {
        setLoading(true);
        callViewApi();
        fetchLogs();
    }, [id]);
    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };
    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleAssignInterpreter = () => {
        setModalType('Assign');
        setAssignInterpreter(true);
    };
    const handleAccept = () => {
        setModalType('accept');
        setAssignInterpreter(true);
    };

    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };

    const handleExtraMileage = () => {
        setExtraMileage(true);
    };
    const handleCloseExtraMileage = () => {
        setExtraMileage(false);
    };

    const handleOpenImsModal = () => {
        imsReset({ ims_id: item?.ims_id || '' });
        setImsModal(true);
    };
    const handleCloseImsModal = () => {
        setImsModal(false);
    };
    const handleImsSubmit = (data) => {
        setLoading(true);
        dispatch(updateVendorImsId(id, data, (success, message) => {
            setLoading(false);
            if (success) {
                handleCloseImsModal();
                callViewApi();
                toast.success(message, { className: 'successToast' });
            } else {
                toast.error(message, { className: 'errorToast' });
            }
        }));
    };

    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true)
        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal();
                handleCloseAssignInterpreter();
                handleCloseExtraMileage();
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
            }
            else {
                toast.error(message,
                    { className: "errorToast", }
                );
                setLoading(false)
            }
        }
        if (end_point === 'accept') {
            dispatch(
                acceptVendorAppointment(
                    id,
                    data,
                    submitCallback
                )
            )
        } else {
            dispatch(
                setVendorActionAssign(
                    id,
                    data,
                    end_point,
                    submitCallback
                )
            )
        }
    }

    const mileageCheck = (val) => {
        return item?.appointment_details?.[val];
    }
    const rawDatetime = item?.datetime;
    const formattedDate = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss").format("MMM D, YYYY HH:mm:ss");

    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}
            <div className="row_main_head bg-primary-secondaryCard">
                <h2 className={`main_heading main_heading1`}>
                    View Appointment # {item?.appid} {item?.ims_id && ` - (IMS # ${item?.ims_id})`}
                </h2>
                <div className='text-transform-capitalize main_heading main_heading1'>
                    Status : {item?.status?.replace(/_/g, ' ')}
                </div>
            </div>
            <div className="row_main_head bg-light-secondaryCard mt-3">
                <h2 className={`main_heading2`} toLowerCase={"text-lowercase"}>
                    Date & Time <span className="dateTime">{formattedDate + " (PST)"}</span>
                </h2>
                <div className="mb-3">
                    <div className="text-transform-capitalize main_heading2">
                        <span className="appointmentType">{item?.type}</span>{" "}
                        <span className="appLanguage">{item?.language?.name || item?.other_language}</span>
                    </div>
                </div>
            </div>
            <div className="card_table view_table_custom">
                {(item?.status === 'cancelled' || item?.status === 'vendor_cancelled') && (
                    <div className="softAlert rejected">
                        <h3>Cancellation Reason: {item?.appointment_details?.cancel_reason || 'N/A'}</h3>
                    </div>
                )}
                {(mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == null) ?
                    <div className='softAlert waiting'>
                        <h3>We've received your request for extra mileage — awaiting admin approval.</h3>
                    </div>
                    :
                    (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 1) ?
                        <div className='softAlert approved'>
                            <h3>The extra mileage request for this appointment have been approved.</h3>
                        </div>
                        : (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 0) ?
                            <div className='softAlert rejected'>
                                <h3>The extra mileage request for this appointment have been rejected.</h3>
                            </div>
                            :
                            ''
                }

                <div className='row-primary flex-wrap'>
                    {/* {(item?.appointment_details?.extra_mileage_request == null && item?.status !== "completed") &&
                        <SubmitButton buttonType="button" className={'lightBlue'} btnText="Request extra mileage" handleSubmit={handleExtraMileage} />
                    } */}
                    {item?.status == "open" &&
                        <SubmitButton buttonType="button" className={'green'} btnText={'Accept'} handleSubmit={handleAccept} />
                    }
                    {(item?.status == "pending" || item?.status == "assigned") &&
                        <SubmitButton buttonType="button" className={'green'} btnText={item?.interpreter_id ? "Reassign" : "Assign"} handleSubmit={handleAssignInterpreter} />
                    }
                    {/* {(item?.status !== "CNC" && item?.status !== "cancelled" && item?.status !== "completed") && <SubmitButton buttonType="button" btnText="Could Not Cover" className="yellow" handleSubmit={handleCouldNotCover} />} */}
                    {(item?.status == "pending" || item?.status == "assigned") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Cancel" handleSubmit={handleCancel} />}
                    {(item?.status == "assigned") &&
                        <SubmitButton buttonType="button" className="Cancle_button"
                            btnText="Checkin / checkout"
                            data-bs-toggle="modal"
                            data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                    }
                    {(['pending', 'assigned', 'completed'].includes(item?.status)) &&
                        <SubmitButton buttonType="button" className="lightBlue" btnText="Edit IMS ID" handleSubmit={handleOpenImsModal} />
                    }

                </div>

                <ViewTable item={item} />
            </div>

            <div className="card_table p-4 mt-3">
                <div className="row_main_head mb-3">
                    <h2 className="main_heading">Appointment Logs</h2>
                </div>
                <LogsTable logs={logs} />
            </div>

            <div className="card_table p-4 mt-3">
                <div className="row_main_head mb-3">
                    <h2 className="main_heading">Notifications Log</h2>
                </div>
                <NotificationLogsTable
                    logs={notificationLogs}
                    onView={(notification) => {
                        setSelectedNotification(notification);
                        setNotificationModal(true);
                    }}
                />
            </div>

            <SelectInterpreterModal
                isVendorForm={true}
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
                modalType={modalType}
            />


            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <ExtraMileage
                isOpen={extraMileage}
                onClose={handleCloseExtraMileage}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />

            <Modal isOpen={imsModal} toggle={handleCloseImsModal} centered className="modal-medium">
                <form onSubmit={imsHandleSubmit(handleImsSubmit)}>
                    <ModalHeader className="header_modal align-items-center">
                        <h5 className="modal-title_u">Edit IMS ID</h5>
                    </ModalHeader>
                    <ModalBody className="modal_form_body">
                        <div className="step_cards step_1" style={{minHeight: 100}}>
                            <div className="row-primary">
                                <h2>Your IMS ID #</h2>
                                <div className="w-100">
                                    <Controller
                                        name="ims_id"
                                        control={imsControl}
                                        render={({ field }) =>
                                            <div style={{ width: '100%' }}>
                                                <input
                                                    {...field}
                                                    type="text"
                                                    className="input-in type_inp"
                                                    placeholder="Enter your IMS ID (optional)"
                                                />
                                            </div>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton btnText="Save" loader={loading} />
                        <button className="table_delete" type="button" onClick={handleCloseImsModal}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>

            <Modal 
                isOpen={notificationModal} 
                toggle={() => setNotificationModal(false)} 
                centered 
                size="lg"
            >
                <ModalHeader toggle={() => setNotificationModal(false)} className="header_modal align-items-center">
                    <h5 className="modal-title_u">Notification Email Preview</h5>
                </ModalHeader>
                <ModalBody className="modal_form_body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <div className="mb-2"><strong>To:</strong> {selectedNotification?.recipient}</div>
                    <div className="mb-2"><strong>Subject:</strong> {selectedNotification?.subject}</div>
                    <div className="mb-3"><strong>Sent At:</strong> {selectedNotification?.created_at ? moment.utc(selectedNotification.created_at).tz("America/Los_Angeles").format("MMM D, YYYY, h:mm A") : ""}</div>
                    <hr />
                    <div 
                        dangerouslySetInnerHTML={{ __html: selectedNotification?.content_html }} 
                        style={{ 
                            border: '1px solid #e5e7eb', 
                            padding: '20px', 
                            borderRadius: '6px', 
                            backgroundColor: '#fff',
                            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)'
                        }}
                    />
                </ModalBody>
                <ModalFooter>
                    <button className="table_delete" type="button" onClick={() => setNotificationModal(false)}>Close</button>
                </ModalFooter>
            </Modal>
        </div>
    );
}





export default AppointmentView